import React from 'react'
import PageContainer from '../../layout/PageContainer';
import CorredorGarantiaPolicyList from './CorredorGarantiaPolicyList';


const CorredorGarantiaPolicyListContainer = () => (
  <PageContainer
    breadcrumbs={[
      { id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
      { id: 1, name: 'CORREDOR', url: '/corredor/polizas-garantia' },
      { id: 2, name: 'PÓLIZAS GARANTÍA'},
    ]}
    clientFilter={{
      type: 'corredor',
      ramo: 'garantia',
      showFilter: true,
    }}
  >
    {(corredor) => (
      <CorredorGarantiaPolicyList corredor={corredor} />
    )}
  </PageContainer>
);

export default CorredorGarantiaPolicyListContainer;
